import React from 'react'
import { useLocation } from 'react-router-dom'

const DetailsHealth = () => {
  const {
    state
  } = useLocation()
  return (
    <div>
      <ul>
        <li>{state.name}</li>
        <li>{state.description}</li>
        <li>{state.id}</li>
        <li>{state.stars}</li>
        <li>{state.address}</li>
      </ul>
    </div>
  )
}

export default DetailsHealth